import { render, staticRenderFns } from "./ImportTrades.vue?vue&type=template&id=73c51fcc"
import script from "./ImportTrades.vue?vue&type=script&lang=js"
export * from "./ImportTrades.vue?vue&type=script&lang=js"
import style0 from "./ImportTrades.vue?vue&type=style&index=0&id=73c51fcc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports